import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AbstractOrderContextModule } from "@spartacus/cart/base/components";
import { I18nModule, FeaturesConfigModule, provideDefaultConfig, CmsConfig, provideConfig } from "@spartacus/core";
import { OrderConfirmationItemsComponent, OrderConfirmationGuard, OrderConfirmationOrderEntriesContext, OrderConfirmationShippingComponent } from "@spartacus/order/components";
import { OrderConfirmationOrderEntriesContextToken, OrderOutlets } from "@spartacus/order/root";
import { CardModule, PwaModule, PromotionsModule, FormErrorsModule, OutletModule, PasswordVisibilityToggleModule, provideOutlet } from "@spartacus/storefront";
import { GonvarriOrderConfirmationItemsComponent } from "src/app/components/gonvarri-order-confirmation/gonvarri-order-confirmation-items/gonvarri-order-confirmation-items.component";
import { GonvarriCartSharedModule } from "../gonvarri-cart-shared-module/gonvarri-cart-shared-module.module";


const orderConfirmationComponents = [
  GonvarriOrderConfirmationItemsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    CardModule,
    PwaModule,
    PromotionsModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    PasswordVisibilityToggleModule,
    AbstractOrderContextModule,
    FeaturesConfigModule,
    GonvarriCartSharedModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {

        OrderConfirmationItemsComponent: {
          component: GonvarriOrderConfirmationItemsComponent,
          guards: [OrderConfirmationGuard],
        },

      },
    }),
  ],
  declarations: [...orderConfirmationComponents],
  exports: [...orderConfirmationComponents],
})
export class GonvarriOrderConfirmationModule {}
